/* eslint-disable @typescript-eslint/no-unused-vars */
import { Card, CardBody, Col, Container, Input, Label, Row } from "reactstrap";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
} from "reactstrap";
import DataTable, { TableColumn } from "react-data-table-component";
// import CollapseFilterData from './CollapseFilterData';
import { useEffect, useMemo, useState } from "react";
import { SearchTableButton } from "../../../../utils/Constant";
import {
  ProductListTableAction,
  ProductListTableProductName,
  ProductListTableStatus,
} from "../../../../Data/Application/Ecommerce/TicketList";
import TicketListFilterHeader from "./TicketListFilterHeader";
import api from "../../../../utils/api";
import { TicketListTableDataColumnType } from "../../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import { SVG } from "../../../../AbstractElements";

const TicketPlanListContainer = () => {
  const [filterText, setFilterText] = useState("");
  const [ticketListTableDatas, setTicketListTableDatas] = useState<
    TicketListTableDataColumnType[]
  >([]);

const [currentPage, setCurrentPage] = useState(1);
const [pageSize, setPageSize] = useState(10);
const [totalRows, setTotalRows] = useState(0);
const [loading, setLoading] = useState(false);

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editData, setEditData] = useState<any>(null);

  // useEffect(() => {
  //   const fetchTickets = async () => {
  //     try {
  //       const response = await api.get("api/AdultPlan/GetAdultPlan"); 
  //       if (response.status === 200) {
  //         setTicketListTableDatas(
  //           response.data.map(
  //             (item: {
  //               adultPlanId: any;
  //               planName: any;
  //               planPrice: any;
  //               seasonalPrice: any;
  //               seasonalStatus: any;
  //               clothPrice: any;
  //             }) => ({
  //               adultPlanId: item.adultPlanId,
  //               name: item.planName,
  //               ticket_price: item.planPrice,
  //               seasonal_price: item.seasonalPrice,
  //               cloth_price: item.clothPrice, 
  //               seasonal_status: item.seasonalStatus ? "Active" : "Inactive",
  //             })
  //           )
  //         );
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch ticket list:", error);
  //     }
  //   };

  //   fetchTickets();
  // }, []);


  const fetchTickets = async (page: number, size: number) => {
  try {
    setLoading(true);
    const response = await api.get(
      `api/AdultPlan/GetAdultPlanPagination?pageNumber=${page}&pageSize=${size}`
    );
    if (response.status === 200) {
      setTicketListTableDatas(
        response.data.items.map(
          (item: {
            adultPlanId: any;
            planName: any;
            planPrice: any;
            seasonalPrice: any;
            seasonalStatus: any;
            clothPrice: any;
          }) => ({
            adultPlanId: item.adultPlanId,
            name: item.planName,
            ticket_price: item.planPrice,
            seasonal_price: item.seasonalPrice,
            cloth_price: item.clothPrice,
            seasonal_status: item.seasonalStatus ? "Active" : "Inactive",
          })
        )
      );
      setTotalRows(response.data.totalCount); // ⬅️ IMPORTANT
    }
  } catch (error) {
    console.error("Failed to fetch ticket list:", error);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
  fetchTickets(currentPage, pageSize);
}, [currentPage, pageSize]);

  const handleDelete = async (id: number) => {
    // Your delete logic here (API call, state update, etc.)
    // console.log("Deleting ID:", id);
    try {
      await api.delete(`/api/AdultPlan/DeleteAdultPlan?planId=${id}`);
      Swal.fire("Deleted!", "The ticket plan has been deleted.", "success");

      // Optional: refresh the list
      setTicketListTableDatas((prev) =>
        prev.filter((item: { adultPlanId: any }) => item.adultPlanId !== id)
      );
    } catch (error) {
      Swal.fire("Error!", "Failed to delete the ticket plan.", "error");
      console.error("Delete error:", error);
    }
  };

  // Edit

  const handleEdit = (row: any) => {
    setEditData(row);
    setEditModalOpen(true);
  };

  const handleEditChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleEditSave = async () => {
    try {
      await api.put(`/api/AdultPlan/UpdateAdultPlan`, {
        adultPlanId: editData.adultPlanId,
        planName: editData.name, 
        planPrice: Number(editData.ticket_price), 
        clothPrice: "0", 
        seasonalPrice: String(editData.seasonal_price), 
        seasonalStatus: editData.seasonal_status === "Active",
      });
      // setTicketListTableDatas((prev) =>
      //   prev.map((item: any) =>
      //     item.adultPlanId === editData.adultPlanId ? editData : item
      //   )
      // );
       await fetchTickets(currentPage, pageSize);
      setEditModalOpen(false);
      Swal.fire("Updated!", "The ticket plan has been updated.", "success");
    } catch (error) {
      Swal.fire("Error!", "Failed to update the ticket plan.", "error");
    }
  };

  const productListTableDataColumn: TableColumn<TicketListTableDataColumnType>[] =
    [
      {
        name: "Plan Name",
        cell: (row) => <ProductListTableProductName name={row.name} />,
        grow: 2,
      },
      {
        name: "Ticket Price",
        selector: (row) => `${row.ticket_price}`,
      },
      {
        name: "Seasonal Price",
        selector: (row) => `${row.seasonal_price}`,
      },
      {
        name: "Seasonal Status",
        cell: (row) => <ProductListTableStatus name={row.seasonal_status} />,
      },
      // {
      //   name: "Action",
      //   cell: (row) => <ProductListTableAction adultPlanId={row.adultPlanId} onDelete={handleDelete} />,
      // },
      {
        name: "Action",
        cell: (row) => (
          <div className="d-flex align-items-center gap-2">
            <span
              onClick={() => handleEdit(row)}
              title="Edit"
              style={{ cursor: "pointer" }}
            >
              <SVG
                iconId="edit-content"
                style={{ fill: "blue", width: 18, height: 18 }}
              />
            </span>
            {/* <span
              onClick={() => handleDelete(Number(row.adultPlanId))}
              title="Delete"
              style={{ cursor: "pointer" }}
            >
              <SVG
                iconId="trash1"
                style={{ fill: "red", width: 18, height: 18 }}
              />
            </span> */}
          </div>
        ),
      },
    ];

  const filteredItems = ticketListTableDatas.filter(
    (item: { name: any }) =>
      item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
  );

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <div className="dataTables_filter d-flex align-items-center">
        <Label className="me-2">{SearchTableButton}:</Label>
        <Input
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setFilterText(e.target.value)
          }
          type="search"
          value={filterText}
        />
      </div>
    );
  }, [filterText]);

  const handlePageChange = (page: number) => {
  setCurrentPage(page);
};

const handlePerRowsChange = (newPerPage: number, page: number) => {
  setPageSize(newPerPage);
  setCurrentPage(page);
};

  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <div className="list-product-header">
                <TicketListFilterHeader />
                {/* <CollapseFilterData /> */}
              </div>
              <div className="list-product">
                <div className="table-responsive">
                  <DataTable
                    data={filteredItems}
                    //  data={ticketListTableDatas}
                    columns={productListTableDataColumn}
                    striped
                    highlightOnHover
                    pagination
                    paginationServer // ⬅️ 
                    paginationTotalRows={totalRows} // ⬅️ 
                    onChangePage={handlePageChange} // ⬅️ 
                    onChangeRowsPerPage={handlePerRowsChange} // ⬅️ 
                    paginationDefaultPage={currentPage} // ⬅️
                    paginationPerPage={pageSize} // ⬅️ 
                    progressPending={loading} // ⬅️ 
                    selectableRows
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal
        isOpen={editModalOpen}
        toggle={() => setEditModalOpen(!editModalOpen)}
      >
        <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>
          Edit Ticket Plan
        </ModalHeader>
        <ModalBody>
          {editData && (
            <>
              <FormGroup>
                <Label>Plan Name</Label>
                <Input
                  name="name"
                  value={editData.name}
                  onChange={handleEditChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Ticket Price</Label>
                <Input
                  name="ticket_price"
                  value={editData.ticket_price}
                  onChange={handleEditChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Seasonal Price</Label>
                <Input
                  name="seasonal_price"
                  value={editData.seasonal_price}
                  onChange={handleEditChange}
                />
              </FormGroup>
              <FormGroup>
                <Label>Seasonal Status</Label>
                <Input
                  type="select"
                  name="seasonal_status"
                  value={editData.seasonal_status}
                  onChange={handleEditChange}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </Input>
              </FormGroup>
              {/* <FormGroup>
                <Label>Cloth Price</Label>
                <Input
                  name="cloth_price"
                  value={editData.cloth_price || ""}
                  onChange={handleEditChange}
                />
              </FormGroup> */}
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setEditModalOpen(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleEditSave}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

export default TicketPlanListContainer;
